import { render } from "./LoadingPage.vue?vue&type=template&id=1ad44016&scoped=true"
const script = {}

import "./LoadingPage.vue?vue&type=style&index=0&id=1ad44016&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad44016"]])

export default __exports__